import type { PaymentMethod } from '@sunflower-games/analytics-events';

import { EnumPaymentMethods } from '../../stores/payredeem/types';

export function mapMethodToAnalytics(method: EnumPaymentMethods | null): PaymentMethod {
  switch (method?.toLowerCase()) {
    case EnumPaymentMethods.card.toLowerCase():
      return 'credit_card';
    case EnumPaymentMethods.skrill.toLowerCase():
      return 'skrill';
    case EnumPaymentMethods.bank.toLowerCase():
      return 'ibt';
    case EnumPaymentMethods.applePay.toLowerCase():
    case EnumPaymentMethods.APPLE_PAY.toLowerCase(): // for backward compatibility
      return 'apple_pay';
    default:
      return 'credit_card';
  }
}
